import React, { useState } from 'react'
import classNames from 'classnames'
import { CustomWorkflowSummary } from '../../../store/customWorkflow/customWorkflows'
import { onActivateKeyDown } from '../../CrossClient/utils'
import styles from '../Workflows.module.scss'

interface RecommendedWorkflowCardProps {
  workflow: CustomWorkflowSummary
  enabled: boolean
  onClick: () => void
}

export const RecommendedWorkflowCard: React.FC<RecommendedWorkflowCardProps> = ({ workflow, enabled, onClick }) => {
  const [hovered, setHovered] = useState<boolean>(false)
  return (
    <div
      className={classNames('d-flex flex-column align-items-start gap-2 p-3 border bg-white h-100', styles.tile, {
        'zocks-border-color-primary': hovered,
        [styles.tileHover]: hovered,
        'zocks-border-color-gray-200': !hovered,
      })}
      role='button'
      tabIndex={0}
      onClick={onClick}
      onKeyDown={onActivateKeyDown(onClick)}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
    >
      <div className='d-flex gap-2 align-items-center justify-content-between w-100'>
        <div className='paragraph-small medium text-truncate'>{workflow.name || workflow.id}</div>
        {enabled ? <span className='px-2 py-1 rounded paragraph-small bold zocks-bg-color-gray-100 zocks-text-gray-900'>Enabled</span> : null}
      </div>
      {workflow.description ? <div className='paragraph-small zocks-text-gray-700'>{workflow.description}</div> : null}
      {workflow.tags.length ? <div className='paragraph-small zocks-text-gray-500'>{workflow.tags.map((tag) => `#${tag}`).join(' ')}</div> : null}
    </div>
  )
}
